import request from '@/utils/request'

// 获取厨房费用列表
export function getKitchenExpenseList(params) {
  return request({
    url: '/kitchen/expense/list',
    method: 'get',
    params: {
      current: params.page,
      size: params.pageSize,
      type: params.type,
      startTime: params.dateRange ? params.dateRange[0] : undefined,
      endTime: params.dateRange ? params.dateRange[1] : undefined,
      keyword: params.keyword,
      expensePerson: params.expensePerson
    }
  })
}

// 添加厨房费用
export function addKitchenExpense(data) {
  return request({
    url: '/kitchen/expense',
    method: 'post',
    data
  })
}

// 更新厨房费用
export function updateKitchenExpense(data) {
  return request({
    url: '/kitchen/expense',
    method: 'put',
    data
  })
}

// 删除厨房费用
export function deleteKitchenExpense(id) {
  return request({
    url: `/kitchen/expense/${id}`,
    method: 'delete'
  })
}
